const USER_STORE_KEY = 'WH_USER__STORE__KEY__'
const DATA_ANALYSIS_TIME = 'WH_DATA__ANALYSIS__TIME'
const DATA__ACQUISITION__TIME = 'WH_DATA__ACQUISITION__TIME'
const projectNameList = 'projectNameList'
const projectId = 'projectId'
const memberProjectId = 'memberProjectId'
const memberId = 'memberId'

export function getUserInfo() {
  return JSON.parse(sessionStorage.getItem(USER_STORE_KEY))
}
export function setUserInfo(userInfo) {
  sessionStorage.setItem(USER_STORE_KEY, JSON.stringify(userInfo))
  return userInfo
}

export function clearUserInfo() {
  sessionStorage.removeItem(USER_STORE_KEY)
  sessionStorage.removeItem(DATA_ANALYSIS_TIME)
  sessionStorage.removeItem(DATA__ACQUISITION__TIME)
  sessionStorage.removeItem(projectNameList)
  sessionStorage.removeItem(projectId)
  sessionStorage.removeItem(memberProjectId)
  sessionStorage.removeItem(memberId)
}
